import React from 'react'
import QtdModulo from '../../ModulosCrefito/QtdModulo'
import AiTipo from './AiTipo'

const AiContainer = () => {
    return (
        <>
            <QtdModulo texto="AUTOS DE INFRAÇÃO" modulo="aifisio" />
            <AiTipo modulo="aifisio" />
        </>
    )
}

export default AiContainer